import React from 'react'
import './HorizontalTimeline.css'


export default function HorizontalTimeline (props) {
    return(
    <ul className="horizontal-timeline">
        <li  data-year={props.years[0]} data-text={props.texts[0]}><a className="eva" href='#1sthp'><div></div></a></li>
        <li data-year={props.years[1]} data-text={props.texts[1]}><a href='#2ndhp'><div></div></a></li> 
        <li data-year={props.years[2]} data-text={props.texts[2]}><a href='#3rdhp'><div></div></a></li>
        <li data-year={props.years[3]} data-text={props.texts[3]}><a href='#4thhp'><div></div></a></li>
        <li data-year={props.years[4]} data-text={props.texts[4]}><a href='#5thhp'><div></div></a></li>
        <li data-year={props.years[5]} data-text={props.texts[5]}><a href='#6thhp'><div></div></a></li>
        <li data-year={props.years[6]} data-text={props.texts[6]}><a href='#7thhp'><div></div></a></li>
        <li data-year={props.years[7]} data-text={props.texts[7]}><a href='#8thhp'><div></div></a></li>
        <li data-year={props.years[8]} data-text={props.texts[8]}><a href='#9thhp'><div></div></a></li>
        <li data-year={props.years[9]} data-text={props.texts[9]}><a href='#10thhp'><div></div></a></li>
        <li data-year={props.years[10]} data-text={props.texts[10]}><a href='#11thhp'><div></div></a></li>
        <li data-year={props.years[11]} data-text={props.texts[11]}><a href='#12thhp'><div></div></a></li>
        <li data-year={props.years[12]} data-text={props.texts[12]}><a href='#13thhp'><div></div></a></li>
        <li data-year={props.years[13]} data-text={props.texts[13]}><a href='#14thhp'><div></div></a></li>
        <li data-year={props.years[14]} data-text={props.texts[14]}><a href='#15thhp'><div></div></a></li>
        <li data-year={props.years[15]} data-text={props.texts[15]}><a href='#16thhp'><div></div></a></li>
        <li data-year={props.years[16]} data-text={props.texts[16]}><a href='#17thhp'><div></div></a></li>
        <li data-year={props.years[17]} data-text={props.texts[17]}><a href='#18thhp'><div></div></a></li>
        <li data-year={props.years[18]} data-text={props.texts[18]}><a href='#19thhp'><div></div></a></li>
        <li data-year={props.years[19]} data-text={props.texts[19]}><a href='#20thhp'><div></div></a></li>
    </ul> 
    )
}